import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Table, Modal } from "react-bootstrap";
import {
  onHandleHover,
  onHandleHoverDone,
  getDateColor,
  getLastUpdatedDateColor,
  getLastUpdatedTootlTip,
  getBookedVacationTooltip,
  sumHour,
  useSortableData
} from "../../dashboard-util/dashboard-utils";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import "../dashboard-consumer-retail.scss";
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import ProgressPill from "../../dashboard-shared/progress-pill/progress-pill";
import DynamicFieldBulk from "../../../../components/DynamicFieldBulk/DynamicFieldBulk";

// Custom Consumer Retail Dashboard Widget
const DashboardMemberTimeLog = (props) => {
  const [members, setMembers] = useState(props.items?.Item1 ? props.items.Item1 : null);
  const [isStaffer, setIsStaffer] = useState(props.items?.Item2 ? props.items.Item2 : false);
  const [projectTypeId, setProjectTypeId] = useState(props.items?.Item3 ? props.items.Item3 : 0);
  const [taskTypeId, setTaskTypeId] = useState(props.items?.Item4 ? props.items.Item4 : 0);
  const [show, setShow] = useState(false);
  const [selectedMember, setselectedMember] = useState(null);
  const [modalType, setSelectedModalType] = useState(null);

  useEffect(() => {
    if (props.items) {
      setMembers(props.items.Item1);
      setIsStaffer(props.items.Item2);
      setProjectTypeId(props.items.Item3);
      setTaskTypeId(props.items.Item4);
    }
  }, [props]);

  const showModal = (m, type) => {
    setShow(true);
    setselectedMember(m);
    setSelectedModalType(type);
  }

  const onHide = () => {
    setShow(true);
    setselectedMember(null);
  }

  const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

  const renderTable = (table) => {
    let result = null;
    if (table != null) {
      if (modalType === 1) {
        let sumCommingWeek = "-";
        let sumWeekend = "-"
        let sumTotal = "-"
        let sumLastWeek = "-"
        result = (
          <Table className="dashboard-table stickyTable">
            <thead className="header stickyHeader">
              <th>CLIENT NAME</th>
              <th>PROJECT</th>
              <th className="col-md-2">MEMBERS</th>
              <th className="col-md-1">DUE DATE</th>
              <th>EST. HOURS THIS COMING WEEK</th>
              <th>EST. WEEKEND HOURS</th>
              <th>TOTAL HOURS</th>
              <th>LAST WEEK HOURS</th>
              <th>NOTE TO STAFFER</th>
              {getLastUpdatedTootlTip(<th>LAST UPDATED</th>)}
            </thead>
            <tbody>
              {table?.Projects && table.Projects.map((tdata) => {
                sumCommingWeek = sumHour(sumCommingWeek, tdata.CurrentWeekHours?.Time);
                sumWeekend = sumHour(sumWeekend, tdata.WeekendHours?.Time);
                sumTotal = sumHour(sumTotal, tdata.TotalHours?.Time);
                sumLastWeek = sumHour(sumLastWeek, tdata.LastWeekHours?.Time);
                return (
                  <tr>
                    <td className="text-break">{tdata.ClientName}</td>
                    <td className="text-break">{tdata.Project?.Name}</td>
                    <td className="text-break pt-4 col-md-2">
                      <ViewMembersPanelNew
                        UserID={tdata.Project?.OwnerId}
                        members={tdata.Project?.Members}
                        projects={tdata.Project}
                        isHidden={true}
                      ></ViewMembersPanelNew>
                    </td>
                    <td className="col-md-1">
                      <ProgressPill start={tdata.Project?.Start} end={tdata.Project?.End} sortBy={"upcoming due dates"} />
                    </td>
                    <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.CurrentWeekHours?.Time ?? "-"}</td>
                    <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.WeekendHours?.Time ?? "-"}</td>
                    <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.TotalHours?.Time ?? "-"}</td>
                    <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.LastWeekHours?.Time ?? "-"}</td>
                    <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.NoteToStaffer}</td>
                    <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"} style={{ color: tdata.IsOldData ? "" : getLastUpdatedDateColor(tdata.LastUpdated) }}>{tdata.LastUpdated ?? "-"}</td>
                  </tr>
                );

              })}

              <tr className="totalRow">
                <td className="text-break"><b>Total</b></td>
                <td className="text-break">-</td>
                <td className="text-break">-</td>
                <td className="text-break">-</td>

                <td className="text-break">{sumCommingWeek}</td>
                <td className="text-break">{sumWeekend}</td>
                <td className="text-break">{sumTotal}</td>
                <td className="text-break">{sumLastWeek}</td>
                <td className="text-break">-</td>
                <td className="text-break">-</td>
              </tr>
            </tbody>
          </Table>
        );
      } else if (modalType === 2) {
        result = (
          <Table className="dashboard-table">
            <thead className="header">
              <th>START DATE</th>
              <th>END DATE</th>
              <th>DESCRIPTION</th>
            </thead>
            <tbody>
              {table?.BookedVacations && table.BookedVacations.map((tdata) => {
                return (
                  <tr>
                    <td className="text-break">{tdata.startDateValue}</td>
                    <td className="text-break">{tdata.endDateValue}</td>
                    <td className="text-break">{tdata.Description}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )
      }
      else {
        result = (
          <DynamicFieldBulk
            objectType={"TaskComment"}
            objectId={0}
            taskTypeId={taskTypeId}
            projectTypeId={projectTypeId}
            columnNamesNotNeeded={["Description"]}
            fetchData={props.fetchData}
            hasProjectColumn={true}
            hasMemberColumn={true}
            hasDueDate={true}
          />
        )
      }
    }
    return result;
  };

  if (items != null && items.length > 0) {
    return (
      <div className="new-dashboard table-wrapper mt-4">
        <div className="DashboardTableWrapper">
          <div>
            <tr className="DashboardTableHeader">
              <th className="DashboardTableTitle">
                Member Time Log
                <p className="subDepartmentTitle">Consumer & Retail</p>
              </th>
            </tr>
          </div>
          <div className = "scrollable-dashboard">
          <table >
            {/* Member and Deals table  */}
            <thead className="MemberTableColumnHeader sticky-header-dashboard">
              <tr className="tableColumnTitles tableHeader">
                <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                <div onClick={() => requestSort('Name')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted"> MEMBER</p>
                            </div>
                            {
                              getArrowDirectionFor("Name", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("Name", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("Name") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>
                  </th>

                <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                <div onClick={() => requestSort('CurrentWeekHours')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted textEllipsis">EST. HOURS THIS COMING WEEK</p>
                            </div>
                            {
                              getArrowDirectionFor("CurrentWeekHours", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("CurrentWeekHours", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("CurrentWeekHours") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>

                </th>



                <th className="col-md-2 col-sm-1 textEllipsis headerSorted">

                <div onClick={() => requestSort('WeekendHours')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted textEllipsis">EST. WEEKEND HOURS</p>
                            </div>
                            {
                              getArrowDirectionFor("WeekendHours", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("WeekendHours", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("WeekendHours") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>

                </th>

                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">

                <div onClick={() => requestSort('TotalHours')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted textEllipsis">TOTAL HOURS</p>
                            </div>
                            {
                              getArrowDirectionFor("TotalHours", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("TotalHours", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("TotalHours") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>

                </th>

                <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                <div onClick={() => requestSort('LastWeekHours')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted">LAST WEEK HOURS</p>
                            </div>
                            {
                              getArrowDirectionFor("LastWeekHours", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("LastWeekHours", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("LastWeekHours") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>
                </th>




                {getBookedVacationTooltip(<th className="col-md-2 col-sm-1 textEllipsis headerSorted">

                <div onClick={() => requestSort('BookedVacation')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted">BOOKED VACATION</p>
                            </div>
                            {
                              getArrowDirectionFor("BookedVacation", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("BookedVacation", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("BookedVacation") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>
                </th>)}
                {getLastUpdatedTootlTip(<th className="col-md-2 col-sm-1 textEllipsis headerSorted">

                <div onClick={() => requestSort('LastUpdated')} className={'sortedCenter'}>
                            <div className="containerTextSorted">
                              <p className="textSorted">LAST UPDATED</p>
                            </div>
                            {
                              getArrowDirectionFor("LastUpdated", "descending") && (
                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                              )
                            }
                            {
                              getArrowDirectionFor("LastUpdated", "ascending") && (
                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                              )
                            }
                            {
                              getArrowDirectionFor("LastUpdated") && (
                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                              )
                            }
                          </div>
                </th>)}
              </tr>
            </thead>
            <tbody className="tableBody">
              {items &&
                items.map((m) => {
                  return (
                    <tr key={m?.Name}>
                      <td className="col-md-1 col-sm-1 mt-2 hover"
                        onMouseLeave={(e) => onHandleHoverDone(e)}
                        onMouseEnter={(e) => onHandleHover(e)}
                        onClick={() => showModal(m, isStaffer?1:3)}>
                        {m.Name}
                      </td>
                      <td className={(m.IsOldData ? "isOldData " : "") + "col-md-2 col-sm-1 mt-2"}>
                        {m.CurrentWeekHours?.Time ?? "-"}
                      </td>
                      <td className={(m.IsOldData ? "isOldData " : "") + "col-md-2 col-sm-1 mt-2"}>
                        {m.WeekendHours?.Time ?? "-"}
                      </td>
                      <td className={(m.IsOldData ? "isOldData " : "") + "col-md-1 col-sm-1 mt-2"}>
                        {m.TotalHours?.Time ?? "-"}
                      </td>
                      <td className={(m.IsOldData ? "isOldData " : "") + "col-md-2 col-sm-1 mt-2"}>
                        {m.LastWeekHours?.Time ?? "-"}
                      </td>
                      <td className="col-md-1 col-sm-1 mt-2 hover"
                        onMouseLeave={(e) => onHandleHoverDone(e)}
                        onMouseEnter={(e) => onHandleHover(e)}
                        onClick={() => showModal(m, 2)}
                        style={{ color: getDateColor(m.VacationPeriod?.DateRangeColor) }}>
                        {m.VacationPeriod?.BookedVacation ?? "-"}
                      </td>
                      <td className="col-md-2 col-sm-1 mt-2"
                        style={{ color: getLastUpdatedDateColor(m.LastUpdated) }}>
                        {m.LastUpdated ?? "-"}
                      </td>                      
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {selectedMember && 
          <Modal
            show={show}
            onHide={onHide}
            contentClassName="dashboard-modal-styles"
            dialogClassName="dashboard-modal"
            scrollable={true}
          >
            <Modal.Header
              className="dashboard-modal-header"
              closeButton
            >
              <Modal.Title className="dashboard-modal-title ml-4 ">
                {selectedMember.Name}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="scrollable">
              {renderTable(selectedMember)}
            </Modal.Body>
          </Modal>}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

DashboardMemberTimeLog.propTypes = {
  items: PropTypes.shape({
    Item1: PropTypes.array,
    Item2: PropTypes.bool,
    Item3: PropTypes.number,
    Item4: PropTypes.number,
  }),
  fetchData: PropTypes.func,
};

export default DashboardMemberTimeLog;
